export enum LoginStep {
  PHONE_ENTER = 'phoneEnter',
  CODE_ENTER = 'codeEnter',
}
